module.exports = __webpack_public_path__ + "images/CarGurus-8b93c7.png";